import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const state = {
	//上传服务器时使用
	urlRoot:"http://www.bracebook.com.cn",
	apiRoot:'',
	//本地测试使用
	//apiRoot:'/api',
	token:'B2016-RUI12_sen30',
	isPC:false,
	userinfo:{
		isLogin:false,
		isValidate:0,
		memberID:'',
		sessionid:'',
		loginName:'',
		nickName:'',
		password:'',
		memberMoney:0,
	},
	consigneeInfo:{
		id:'',
		person:'',
		mobile:'',
		area:'',
		address:''
	},
	inviteInfo:{
		from:'',
		from_memberid:''
	},
	/*
		{
			item_id: '1',
			prod_id:'2',
			name: '改变世界的管理学大师：管理学的奠基者',
			price: 200.56,
			item_num:1,
			imgPath:require('../assets/images/book.jpg'),
			item_type:'1',
			isSelected:true,
			isGift:'0'
		}
	*/
	shopcartprods:[],
	playinfo:{
		album_id:'',
		album_title:'',
		album_author:'',
		album_cover:'',
		album_list:[
			{id:'',title:'',source:''}
		],
		currentIndex:0,
		isPlaying:false
	},
	playControl:{
		isPayable:true,
		isMember:false
	}
}
const mutations = {
     setCart(state,value){

	 },
	 storeproduct(state,value){
		state.shopcartprods.push(value)
	 },
	 addproduct(state,value){
		state.shopcartprods[value.index].item_num=state.shopcartprods[value.index].item_num+value.item_num 
	
	},
	clear(state){
		state.shopcartprods=[]
	},
	shopcartcomputed(state,value){
		state.shopcartprods=value
	},
	deleteproduct(state,i){
		state.shopcartprods.splice(i,1)
	},
	updateProductNum(state,indexedItem){
		state.shopcartprods[indexedItem.index].item_num=indexedItem.item.item_num 
	},
	updateProductState(state,indexedItem){
		state.shopcartprods[indexedItem.index].isSelected=indexedItem.item.isSelected 
	},
	setConsigneeInfo(state,value){
		Object.assign(state.consigneeInfo,value);
	},
	setUserInfo(state,value){
		Object.assign(state.userinfo,value);
	},
	updateLoginState(state,isLogin){
		state.userinfo.isLogin=isLogin;
	},
	setPlayInfo(state,value){
		Object.assign(state.playinfo,value)
	},
	updatePlayState(state,isPlaying){
		state.playinfo.isPlaying=isPlaying
	},
	updatePlayIndex(state,playIndex){
		state.playinfo.currentIndex=playIndex
	},
	updateMembmerState(state,value){
		state.playControl.isMember=value;
	},
	updatePayState(state,value){
		state.playControl.isPayable=value;
	},
	setIsPC(state,value){
		state.isPC=value;
	},
	setInviteInfo(state,inviteInfo){
		Object.assign(state.inviteInfo,inviteInfo);
	},
}
const actions={
	setshopCart({commit,state},product){
		if(state.shopcartprods.length>0){
			new Promise((resolve,reject)=>{
				//1、购物车原全部商品
				let arr=[]
				for(var i=0;i<state.shopcartprods.length;i++){
					arr.push({item_id:state.shopcartprods[i].item_id})
				}
				//2、新添加购物车的商品
				let brr={item_id:product.item_id}
				if(JSON.stringify(arr).indexOf(JSON.stringify(brr))!=-1){	
						for(var i=0;i<state.shopcartprods.length;i++){
							if(arr[i].item_id==brr.item_id) {
								resolve(i)
							}
						}	
				}else{
					reject(state.shopcartprods.length)
				}
			}).then(res=>{//1、购物车已有
					if(product.item_type=='1'){//如果是纸质书,则增加数量
						Object.assign(product,{index:res})
						commit('addproduct',product)
						return	
					}else{//如果是电子书，则判断已有和新增的是否是赠品
						if(state.shopcartprods[res].isGift=='1'){
							return;
						}else{
							if(product.isGift=='1'){
								commit('deleteproduct',res);
								commit('storeproduct',product);
							}
							return;
						}
					}
			},err=>{//2、购物车不存在，则新增
				Object.assign(product,{index:err})
				commit('storeproduct',product)
			})
		}else{
			Object.assign(product,{index:0})
			commit('storeproduct',product)
		}	
	},
	deleteProducts({commit,state}){
		for(var i=state.shopcartprods.length-1;i>=0;i--){
			if(state.shopcartprods[i].isSelected){
				commit('deleteproduct',i);
			}
		}
	},
	updateProductNum({commit,state},indexedItem){
		commit('updateProductNum',indexedItem);
	},
	updateProductState({commit,state},indexedItem){
		if(indexedItem.item.item_type=='0'){
			commit('updateProductState',indexedItem);
		}else{
			for(var i=0;i<state.shopcartprods.length;i++){
				if(state.shopcartprods[i].prod_id==indexedItem.item.prod_id) {
					let item=state.shopcartprods[i]
					item.isSelected=indexedItem.item.isSelected
					commit('updateProductState',{index:i,item:item});
				}
			}
		}
	},
	setConsigneeInfo({commit,state},value){
		commit('setConsigneeInfo',value);
	},
	setUserInfo({commit,state},value){
		commit('setUserInfo',value);
	},
	updateLoginState({commit,state},isLogin){
		commit('updateLoginState',isLogin);
	},
	setPlayInfo({commit,state},playinfo){
		commit('setPlayInfo',playinfo);
	},
	updatePlayState({commit,state},isPlaying){
		commit('updatePlayState',isPlaying);
	},
	updatePlayIndex({commit,state},playIndex){
		commit('updatePlayIndex',playIndex);
	},
	updateMembmerState({commit,state},value){
		commit('updateMembmerState',value);
	},
	updatePayState({commit,state},value){
		commit('updatePayState',value);
	},
	setIsPC({commit,state},value){
		commit('setIsPC',value);
	},
	//设置邀请注册信息
	setInviteInfo({commit,state},inviteInfo){
		commit('setInviteInfo',inviteInfo);
	},
}
const getters ={
      shopcartdata:(state)=>{
		   let cartdata={
			   price:0,
			   num:0,
			   total:0
		   }
           for(let i=0;i<state.shopcartprods.length;i++){
			   if(state.shopcartprods[i].isSelected){
					cartdata.price=state.shopcartprods[i].item_num * state.shopcartprods[i].price+cartdata.price;
					cartdata.num=state.shopcartprods[i].item_num + cartdata.num
			   }
			   cartdata.total=state.shopcartprods[i].item_num + cartdata.total
		   }
		   return cartdata
	  }
}
// 创建 store 实例
export default new Vuex.Store({
	plugins: [createPersistedState()],
	state,
    mutations,
	actions,
	getters,
})


// WEBPACK FOOTER //
// ./src/vuex/store.js